// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-width,.v-badge{width:100%}.v-badge.points-badge .v-badge__badge,.v-badge.student-badge .v-badge__badge,.v-badge.teacher-badge .v-badge__badge{height:22px;width:auto;min-width:22px;padding:0 2px 1px;letter-spacing:0;text-indent:0;border-radius:10px}.v-badge.points-badge .v-badge__badge span,.v-badge.student-badge .v-badge__badge span,.v-badge.teacher-badge .v-badge__badge span{font-size:12px}", ""]);
// Exports
module.exports = exports;
